/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

export const ADD = 'ADD';
export const REMOVE = 'REMOVE';

export default {
  ADD,
  REMOVE,
};
